import { Link } from "react-router-dom";
import styled from "styled-components";
import Typography from "../../Typography";

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const ResendButton = styled.button`
  &:disabled {
    color: var(--white-secondary);
    cursor: default;
  }
`;

export const AgreeWithPolicy = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

export const PrivacyLink = styled(Link)`
  text-decoration: underline;

  &:hover {
    opacity: 0.7;
  }
`;

export const PrivacyText = styled(Typography)`
  line-height: 1;
`;
